import gql from 'graphql-tag'
import { EnumFields } from '..'

export const VehicleGamaFragment = gql`
  fragment VehicleGama on vehicle_gama {
    ${EnumFields}
  }
`
